import React from "react";
import NotificationBell from "./NotificationBell";
import { getLang, setLang } from "../store/uiStore";
import "./Header.css";

export default function Header() {
  const lang = getLang();
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const role = user?.role || "clinic";
  const username = user?.username || "";

  const roleLabels = {
    clinic: { tj: "Муассиса", ru: "Клиника" },
    clinic_inspector: { tj: "Нозир", ru: "Инспектор" },
    regional_inspector: { tj: "Минтақавӣ", ru: "Региональный" },
    central: { tj: "Хадамот", ru: "Служба" },
    admin: { tj: "Админ", ru: "Администратор" },
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  const handleLanguageChange = (nextLang) => {
    setLang(nextLang);
    window.location.reload();
  };

  return (
    <header className="nizom-header">
      <div className="nizom-header-title">Низоми ягона</div>

      <div className="nizom-header-actions">
        {username && (
          <div className="nizom-header-user" title={username}>
            {username}
          </div>
        )}

        <div className="nizom-header-role">
          <span className="nizom-header-role-label">
            {lang === "tj" ? "Нақш:" : "Роль:"}
          </span>
          <span>{roleLabels[role]?.[lang] || role}</span>
        </div>

        <div className="nizom-header-notifications">
          <NotificationBell />
        </div>

        <div className="nizom-header-language" aria-label="Language">
          <button
            type="button"
            onClick={() => handleLanguageChange("tj")}
            className={lang === "tj" ? "active" : ""}
            aria-pressed={lang === "tj"}
          >
            TJ
          </button>
          <button
            type="button"
            onClick={() => handleLanguageChange("ru")}
            className={lang === "ru" ? "active" : ""}
            aria-pressed={lang === "ru"}
          >
            RU
          </button>
        </div>

        <button
          type="button"
          onClick={() => {
            window.location.href = "/change-password";
          }}
          className="nizom-header-action-button"
        >
          {lang === "tj" ? "Ивази рамз" : "Сменить пароль"}
        </button>

        <button
          type="button"
          onClick={handleLogout}
          className="nizom-header-action-button nizom-header-logout"
        >
          {lang === "tj" ? "Баромадан" : "Выйти"}
        </button>
      </div>
    </header>
  );
}
